(() => {
  if (window.spaceDesignReady) return;
  window.spaceDesignReady = true;
  const togglePreview = card => {
    const button = card.querySelector('[data-space-preview]');
    if (!button) return;
    const active = card.classList.toggle('is-alt-view');
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? button.dataset.primaryLabel : button.dataset.secondaryLabel);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-space-preview]');
    if (!button) return;
    event.preventDefault();
    togglePreview(button.closest('product-card'));
  });
  document.addEventListener('change', event => {
    const card = event.target.closest('product-card');
    if (!card || !event.target.matches('input[type="radio"]')) return;
    card.classList.remove('is-alt-view');
    const button = card.querySelector('[data-space-preview]');
    if (button) { button.setAttribute('aria-pressed', 'false'); button.setAttribute('aria-label', button.dataset.secondaryLabel); }
  });
  let gesture;
  document.addEventListener('pointerdown', event => {
    const media = event.target.closest('.product-card__media');
    if (event.pointerType !== 'touch' || !media) { gesture = undefined; return; }
    gesture = { media, x:event.clientX, y:event.clientY };
  }, { passive:true });
  document.addEventListener('pointerup', event => {
    if (!gesture) return;
    const { media,x,y } = gesture;
    gesture = undefined;
    const dx = event.clientX - x, dy = event.clientY - y;
    if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
    const card = media.closest('product-card');
    if (!card.querySelector('[data-space-preview]')) return;
    togglePreview(card);
    media.dataset.spaceSwiped = String(Date.now());
  }, { passive:true });
  document.addEventListener('pointercancel', () => { gesture = undefined; }, { passive:true });
  document.addEventListener('click', event => {
    const media = event.target.closest('.product-card__media');
    if (media && Date.now() - Number(media.dataset.spaceSwiped || 0) < 500) event.preventDefault();
  }, true);
})();
